/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { StreakMultiplierTier } from './StreakMultiplierTier';
import {
    StreakMultiplierTierFromJSON,
    StreakMultiplierTierFromJSONTyped,
    StreakMultiplierTierToJSON,
    StreakMultiplierTierToJSONTyped,
} from './StreakMultiplierTier';

/**
 * The Streak Bonus curve — the multiplier a streak has earned, by length. Applied at payout to the streak's own point-like rewards (Fuel and leaderboard/hub/activity points). XP is deliberately excluded: it already carries LootBox and subscription multipliers, and a third layer makes the number unexplainable to the player.
 * @export
 * @interface StreakActiveMultiplier
 */
export interface StreakActiveMultiplier {
    /**
     * 
     * @type {Array<StreakMultiplierTier>}
     * @memberof StreakActiveMultiplier
     */
    tiers: Array<StreakMultiplierTier>;
    /**
     * Maximum multiplier value — the single number bounding the cost of the mechanic.
     * @type {number}
     * @memberof StreakActiveMultiplier
     */
    cap?: number;
}

/**
 * Check if a given object implements the StreakActiveMultiplier interface.
 */
export function instanceOfStreakActiveMultiplier(value: object): value is StreakActiveMultiplier {
    if (!('tiers' in value) || value['tiers'] === undefined) return false;
    return true;
}

export function StreakActiveMultiplierFromJSON(json: any): StreakActiveMultiplier {
    return StreakActiveMultiplierFromJSONTyped(json, false);
}

export function StreakActiveMultiplierFromJSONTyped(json: any, ignoreDiscriminator: boolean): StreakActiveMultiplier {
    if (json == null) {
        return json;
    }
    return {
        
        'tiers': ((json['tiers'] as Array<any>).map(StreakMultiplierTierFromJSON)),
        'cap': json['cap'] == null ? undefined : json['cap'],
    };
}

export function StreakActiveMultiplierToJSON(json: any): StreakActiveMultiplier {
    return StreakActiveMultiplierToJSONTyped(json, false);
}

export function StreakActiveMultiplierToJSONTyped(value?: StreakActiveMultiplier | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tiers': ((value['tiers'] as Array<any>).map(StreakMultiplierTierToJSON)),
        'cap': value['cap'],
    };
}

